module.exports = __webpack_public_path__ + "img/listview-closejob.25fd5995.svg";